<!-- 浄水器システムの削除 -->
<template>
  <div class="pt-1">
    <v-dialog
      v-model="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <div class="confirm-message">{{confirmMessage}}</div>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :disabled="btnDisable"
            @click.native="showDialog=false"
            tabindex="0"
          >
            {{$t('btn.cancel')}}
          </v-btn>

          <v-btn
            :disabled="isRoot"
            color="primary"
            class="ml-4"
            @click.prevent="deleteFiltrationSystem"
          >
            <!-- {{$t('btn.delete')}} -->
            {{deleteBtnName}}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showResultDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <div class="result-message">{{resultMessage}}</div>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click.native="showResultDialog=false"
            tabindex="0"
          >
            {{$t('btn.ok')}}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'

export default {
  components: {
  },
  // props: ['filtrationSystem'],
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      viewerRoleName: config.role.Viewer,
      filtrationSystem: null,
      validated: false,
      confirmMessage: '',
      resultMessage: '',
      showDialog: false,
      showResultDialog: false,
      showMap: false,
      btnDisable: false,
      isRoot: false,
      deleteBtnName: this.$t('btn.delete') // 削除ボタン名
    }
  },
  watch: {
  },
  methods: {
    init () {
      this.setExecBtnProperty()
    },
    startDialog (filtrationSystem) {
      this.filtrationSystem = filtrationSystem
      this.errorMessage = ''
      this.confirmMessage = this.$t('watersystem.delete-water-system', [filtrationSystem.filtrationSystemName])
      if (this.filtrationSystem.jm1UniqueId) {
        this.confirmMessage += ('\n' + this.$t('watersystem.delete-water-system-with-iotizr'))
      }
      this.confirmMessage += ('\n\n' + this.$t('watersystem.delete-water-system-ask'))
      this.showDialog = true
    },
    deleteFiltrationSystem () {
      this.btnDisable = true // ボタン無効化
      const params = {
        filtrationSystemId: this.filtrationSystem.filtrationSystemId
      }
      http.request('post', '/service2/dashboard/api/FiltrationSystems/deleteFiltrationSystem', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('delete failed. (' + data.result + ')')
            this.resultMessage = this.$t('watersystem.error-delete')
            this.btnDisable = false
            this.showResultDialog = true
            this.showDialog = false
            return
          }
          this.$emit('delete-succeed', this.filtrationSystem.filtrationSystemId)
          this.resultMessage = this.$t('watersystem.succeed-delete')
          this.showResultDialog = true
          this.showDialog = false
        })
        .catch(error => {
          console.log('error', error)
          this.resultMessage = this.$t('watersystem.error-delete')
          this.showResultDialog = true
          this.btnDisable = false
        })
    },
    // 保存ボタンの属性をセットする
    setExecBtnProperty () {
      this.isRoot = utils.isRoot(this.$store.getters.user.roles) // ルートかどうかを判定
      if (this.isRoot) {
        this.deleteBtnName = this.$t('aplix-use-only.btn.can-not-delete')
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>

.confirm-message {
  white-space: pre-wrap;
}

 </style>



// WEBPACK FOOTER //
// WaterSystemDeleteDialog.vue?332ad13c